import { WebRNModuleAPIs } from "src/components/15-containers/SuperChargedWebView/communication/web2RNCom/WebRNModuleAPIs";
import { isWebView } from "src/utils/platform";
/**
 * Resolves the cached image URL for the given URL
 * If the image is not cached, it will return the original URL
 */
export default async function resolveCachedImageURL(url) {
    if (!isWebView)
        return url;
    // if the url is a file url, then return the url
    if (url.startsWith('file://') || url.startsWith('data:image/'))
        return url;
    const cachedPath = await WebRNModuleAPIs.ImageCache.getCachedPath(url);
    return cachedPath || url;
}
